// extracted by mini-css-extract-plugin
export var lg = "_4p-4";
export var md = "_4p-3";
export var sm = "_4p-2";
export var xs = "_4p-1";
export var xxs = "_4p-0";